import script from "./OrderSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&setup=true&lang=js"

import "./OrderSuccess.vue?vue&type=style&index=0&id=6580c8ed&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6580c8ed"]])

export default __exports__